import * as React from "react"
import {Grid, Skeleton} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import {TitleWithPopover} from "@components";
import {isLoadingCommonFilters} from "@signals";
import {productDetailsEvolutionCurrentSkuData, productDetailsEvolutionSkuData} from "../@signals";
import MarketplacesProductDetailsEvolutionSkuBlock from "./SkuBlock";
import MarketplacesProductDetailsEvolutionChart from "./Chart";


export default function MarketplacesProductDetailsEvolution() {
	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={600} />
	if (!productDetailsEvolutionSkuData.value.length) return <></>

	return <CardSeeker title={<TitleWithPopover title={`${productDetailsEvolutionCurrentSkuData.value.sku} - Evolution`} />}>
		<Grid container spacing={2}>
			<Grid item xs={3}>
				<MarketplacesProductDetailsEvolutionSkuBlock />
			</Grid>
			<Grid item xs={9}>
				<MarketplacesProductDetailsEvolutionChart />
			</Grid>
		</Grid>
	</CardSeeker>
}